import { Notification, NotificationDto } from '../interfaces/supabase/notifications/types';

export function mapNotificationDtoToNotification(dto: NotificationDto): Notification {
  return {
    id: dto.id,
    type: dto.type,
    title: dto.title,
    text: dto.text,
    createdAt: dto.created_at,
    order: dto.order,
    userId: dto.user_id,
    meta: dto.meta,
  };
}
